import { useCallback, useState } from 'react';
import { copyRichTextToClipboard } from '@hiredigital/lib/helpers/utils';
import Button from '@hiredigital/ui/Button/Button';
import InteractiveButton from '@components/InteractiveButton/InteractiveButton';

const CopyToClipboard = ({ className, forRef: elem, label = 'Copy to Clipboard' }) => {
  const [buttonLabel, setButtonLabel] = useState(label);
  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      let ok = false;
      try {
        ok = copyRichTextToClipboard(elem);
        if (ok) {
          setButtonLabel('Copied!');
          setTimeout(() => {
            setButtonLabel(label);
          }, 2000);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (!ok) alert("Couldn't copy. Please select the text and copy manually.");
      }
    },
    [elem, label]
  );

  return (
    <InteractiveButton
      className={className}
      type={Button.Type.BLUE}
      onClick={handleClick}
      title={label}>
      {buttonLabel}
    </InteractiveButton>
  );
};

export default CopyToClipboard;
